import type { ShoppingBagItem } from '@ori-events/basket-updated';
import { Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { Footer } from '../Footer';
import { FormattedMessage } from '../FormattedMessage';
import { Header } from '../Header';
import { Item } from '../Item';
import { LoadingOverlay } from '../LoadingOverlay';
import { EmptyBag, Items, ItemsWrapper, Root } from './styles';
import type { MiniBagProps } from './types';

export const MiniBag: FC<MiniBagProps> = ({
  breakpointIndex,
  isBasketSharingEnabled,
  items,
  isDataLoaded,
  isLoading,
  onMouseEnter,
  onMouseLeave,
  useOpenedMinibagOnDesktop,
}) => {
  const quantity = items.reduce((total, current) => total + current.requestedQuantity, 0);
  const { getTestIdProps } = useTestId();
  const ownerState = { breakpointIndex, useOpenedMinibagOnDesktop };
  const itemsOwnerState = { isBasketSharingEnabled };
  const rootProps = { onMouseEnter, onMouseLeave, ownerState, ...getTestIdProps('content') };
  const isSharingButtonActive = items.length > 0;
  const footerProps = { isBasketSharingEnabled, isSharingButtonActive };

  return (
    <Root {...rootProps}>
      <Header quantity={quantity} />
      {isLoading || !isDataLoaded ? <LoadingOverlay isBasketSharingEnabled={isBasketSharingEnabled} /> : null}
      <ItemsWrapper {...getTestIdProps('items')}>
        {items.length > 0 && (
          <Items ownerState={itemsOwnerState}>
            {items.map((item: ShoppingBagItem) => (
              <Item
                key={`minibag-item-${item.lineNumber}-${item.itemCode}-${item.itemType}-${item.totalPrice}`}
                {...item}
              />
            ))}
          </Items>
        )}
        {isDataLoaded && items.length === 0 ? (
          <EmptyBag {...getTestIdProps('empty')}>
            <Typography variant="h6">
              <FormattedMessage id="emptyBag" />
            </Typography>
            <Typography variant="body1">
              - <FormattedMessage id="emptyBagMessage" /> -
            </Typography>
          </EmptyBag>
        ) : null}
      </ItemsWrapper>
      <Footer {...footerProps} />
    </Root>
  );
};
